import { Outlet, createFileRoute, notFound, useLocation } from "@tanstack/react-router";
import { Navbar } from "@/components/navbar";
import { NavProgress } from "@/components/nav-progress";
import { FeedbackButton } from "@/components/feedback-button";
import { useAuth } from "@/hooks/use-auth";

export const Route = createFileRoute("/_main")({
  beforeLoad: ({ context }) => {
    if (context.auth.loading) return;
    if (!context.auth.isAuthenticated) {
      throw notFound();
    }
  },
  component: MainLayout,
});

function MainLayout() {
  const { loading } = useAuth();
  const pathname = useLocation({ select: (s) => s.pathname });
  const isTakingTest = /\/exams\/[^/]+\/test\/[^/]+$/.test(pathname);

  if (loading) {
    return (
      <div className="flex min-h-svh items-center justify-center">
        <div className="size-6 animate-spin rounded-full border-2 border-zinc-300 border-t-zinc-700" />
      </div>
    );
  }

  return (
    <div className="flex min-h-screen flex-col bg-zinc-50 dark:bg-zinc-950">
      <NavProgress />
      <Navbar />
      {isTakingTest ? (
        <main className="flex-1">
          <Outlet />
        </main>
      ) : (
        <main className="flex-1 px-4 py-6 sm:px-6 sm:py-8 md:py-10">
          <div className="mx-auto w-full max-w-6xl">
            <Outlet />
          </div>
        </main>
      )}
      <FeedbackButton />
    </div>
  );
}
